import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { WixLoginStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

export const useYupLoginLandingWixValidationSchema = () => {
  const { t } = useTranslation();
  const yupLoginLandingWixValidationSchema = useMemo(() => {
    return {
      [WixLoginStepFormFieldsEnum.PhoneMobile]: yupLanding.string().required(),
    };
  }, []);
  return { yupLoginLandingWixValidationSchema };
};
